<div class="draft-requests-container">
  <div class="draft-requests-header">
    <h2>{{ 'sidebar.drafts' | translate }}</h2>
  </div>

  <!-- Success Message -->
  @if (successMessage) {
    <div class="alert alert-success alert-dismissible fade show" role="alert">
      <i class="bi bi-check-circle me-2"></i>
      {{ successMessage }}
      <button
        type="button"
        class="btn-close"
        (click)="successMessage = ''"
        aria-label="Close">
      </button>
    </div>
  }

  <!-- Filters Section -->
  <!-- Filters removed: RequestType-based filtering no longer used -->

  <!-- Grid Component -->
  <app-common-grid
    [rows]="(requests$ | async) || []"
    [columns]="columns"
    [actions]="actions"
    [loading]="(loading$ | async) || false"
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalRecords]="(totalRecords$ | async) || 0"
    [pageSizeOptions]="pageSizeOptions"
    [showPagination]="true"
    [enableRowClick]="true"
    rowIdentifier="id"
    emptyStateMessageKey="requests.noDrafts"
    (actionTriggered)="onTableAction($event)"
    (rowClick)="onRowClick($event)"
    (pageChange)="loadPage($event)"
    (pageSizeChange)="changePageSize($event)"
  ></app-common-grid>
</div>
